export default {
    computed: {
        items() {
            return [
                {
                    access: ['settingsOrderTest'],
                    path: '/orders/test',
                    icon: 'check',
                    title: this.$t('settings.main.test.title'),
                    lead: this.$t('settings.main.test.lead'),
                },
                {
                    access: ['orderChangeStatus'],
                    path: '/settings/order-change-status',
                    icon: 'sync',
                    title: this.$t('settings.main.orderChangeStatus.title'),
                    lead: this.$t('settings.main.orderChangeStatus.lead'),
                },
                {
                    access: ['settingsManageExternalServices'],
                    path: '/settings/external-services',
                    icon: 'tool',
                    title: this.$t('settings.main.externalServices.title'),
                    lead: this.$t('settings.main.externalServices.lead'),
                },
                {
                    access: ['settingsManageRolesOrderStatuses', 'settingsManagePermissionView', 'settingsManagePermissionEdit'],
                    path: '/settings/roles',
                    icon: 'key',
                    title: this.$t('settings.main.roles.title'),
                    lead: this.$t('settings.main.roles.lead'),
                },
                {
                    access: ['settingsMailing'],
                    path: '/settings/mailing',
                    icon: 'mail',
                    title: this.$t('settings.main.mailing.title'),
                    lead: this.$t('settings.main.mailing.lead'),
                },
                {
                    access: ['settingsEvents'],
                    path: '/settings/events',
                    icon: 'calendar',
                    title: this.$t('settings.main.events.title'),
                    lead: this.$t('settings.main.events.lead'),
                },
                {
                    access: ['settingsSap'],
                    path: '/settings/sap',
                    icon: 'corner-up-right',
                    title: this.$t('settings.main.sap.title'),
                    lead: this.$t('settings.main.sap.lead'),
                },
                {
                    access: ['settingsApp'],
                    path: '/settings/acceptance-acts',
                    icon: 'clock',
                    title: this.$t('settings.main.acceptanceActs.title'),
                    lead: this.$t('settings.main.acceptanceActs.lead'),
                },
                {
                    access: ['settingsAtol', 'settingsSetKit'],
                    path: '/settings/checks/' + (this.checkAccess('settingsAtol') ? 'atol' : 'set-kit'),
                    icon: 'file',
                    title: this.$t('settings.main.check.title'),
                    lead: this.$t('settings.main.check.lead'),
                },
                {
                    access: ['pfmDistributionViewAndEdit'],
                    path: '/settings/distribution',
                    icon: 'arrows-alt',
                    title: this.$t('settings.main.distribution.title'),
                    lead: this.$t('settings.main.distribution.lead'),
                },
                {
                    access: ['settingsTracknumSearch'],
                    path: '/settings/tracknum-search',
                    icon: 'search',
                    title: this.$t('settings.main.tracknumSearch.title'),
                    lead: this.$t('settings.main.tracknumSearch.lead'),
                },
                {
                    access: ['menuViewSettingUIIndex'],
                    path: '/settings/ui',
                    icon: 'edit',
                    title: this.$t('settings.main.ui.title'),
                    lead: this.$t('settings.main.ui.lead'),
                },
                {
                    access: ['reportsViewSettings'],
                    path: '/settings/reports',
                    icon: 'report',
                    title: this.$t('settings.main.reports.title'),
                    lead: this.$t('settings.main.reports.lead'),
                },
                {
                    access: ['settingsReferenceLinks'],
                    path: '/settings/reference',
                    icon: 'question-circle',
                    title: this.$t('settings.main.reference.title'),
                    lead: this.$t('settings.main.reference.lead'),
                },
                {
                    access: ['menuViewSetting'],
                    path: '/settings/alerts',
                    icon: 'alert',
                    title: this.$t('settings.main.alerts.title'),
                    lead: this.$t('settings.main.alerts.lead'),
                },
            ];
        },
    },
};